export default __webpack_public_path__ + "static/media/logo.408e2a7b.png";